import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ_ITEMS } from "../lib/constants";

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700 mb-3">
            Questions fréquentes
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900">
            Vos questions, nos réponses
          </h2>
          <p className="text-slate-600 mt-3">
            Des réponses claires pour vous accompagner en toute sérénité.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="border border-slate-200 rounded-2xl overflow-hidden bg-white"
        >
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-slate-200 last:border-0"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="px-6 py-5 hover:bg-slate-50 text-left font-semibold text-slate-900 hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-5 text-slate-600 leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
